import { Grid, Container } from "@mantine/core";
import CategoryBox from "../../components/common/categorybox";
import { getCategoryDrawingBysite } from '../../store/actions';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from 'react-router-dom'; 

const SiteCategory = () => {
  const categories = [
    {
      categoryId: 1,
      category: 'line-drawing',
      name: 'Single Line Drawings'
    },
    {
      categoryId: 2,
      category: 'schematics',
      name: 'Schematics'
    },
    {
      categoryId: 3,
      category: 'electrical',
      name: 'Electrical Drawings'
    },
    {
      categoryId: 4,
      category: 'mechanical',
      name: 'Mechanical Drawings'
    },
    {
      categoryId: 5,
      category: 'fire-safety',
      name: 'Fire Safety Drawings'
    },
    {
      categoryId: 6,
      category: 'asset',
      name: 'Asset List'
    },
    {
      categoryId: 7,
      category: 'equipment',
      name: 'Equipment Layouts'
    },
    {
      categoryId: 8,
      category: 'schedules',
      name: 'Schedules'
    }
  ];

  const dispatch = useDispatch()
  const {siteId} = useParams();

  const { getDrawings,totalCount} = useSelector((state: any) => ({
    getDrawings: state.getManualURL?.drawinglist,
    totalCount: state.getManualURL?.totalCount,
  }));

  const [searchValue, setSearchValue] = useState<any>('');
  const [pageNumber, setPageNumber] = useState(1);
 
  const getList = () => {
    const data = {
      "siteId": siteId,
      "pageNumber": pageNumber,
      "pageSize": totalCount,
      "sortColumn": "",
      "sortDirection": "",
      "searchKeyword": searchValue
    }
    dispatch(getCategoryDrawingBysite(data));
  }
  useEffect(() => {
    if (siteId) {
      getList();
    }
  }, [siteId]);

  useEffect(() => {
    if (siteId && totalCount > 0) {
      getList();
    }
  }, [totalCount]);
  
  const filteredCategories = categories.filter((el) =>
    getDrawings?.some((drawing: any) => drawing.categoryId === el.categoryId)
  );

  return (
    <Container style={{ maxWidth: 1024, paddingTop: '6rem' }}>
      {filteredCategories.length > 0 ? (
        <Grid gutter={{ base: 5, xs: 'md', md: 'xl', xl: 50 }}>
          {filteredCategories.map((el) => {
            const drawingItem = getDrawings?.find(
              (drawing: any) => drawing.categoryId === el.categoryId
            );
            return (
              <Grid.Col span={{ sm: 6, md: 4, lg: 3 }} key={el.categoryId}>
                <CategoryBox
                  from={'drawings'}
                  data={el}
                  //showActionMenu={true}
                  drawingitem={drawingItem}
                  getDrawings={getDrawings} 
                />
              </Grid.Col>
            );
          })}
        </Grid>
      ) : (
        <div className="no-drawing-message">
          No drawing found for the selected site.
        </div>
      )}
    </Container>
  );
}

export default SiteCategory;